package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets20 {
  internal val names_11_melachim_b_18_txt: AssetResource by lazy { init_names_11_melachim_b_18_txt()
      }

  internal val names_11_melachim_b_19_txt: AssetResource by lazy { init_names_11_melachim_b_19_txt()
      }

  internal val names_11_melachim_b_20_txt: AssetResource by lazy { init_names_11_melachim_b_20_txt()
      }

  internal val names_11_melachim_b_21_txt: AssetResource by lazy { init_names_11_melachim_b_21_txt()
      }

  internal val names_11_melachim_b_23_txt: AssetResource by lazy { init_names_11_melachim_b_23_txt()
      }

  internal val names_11_melachim_b_24_txt: AssetResource by lazy { init_names_11_melachim_b_24_txt()
      }

  internal val names_11_melachim_b_25_txt: AssetResource by lazy { init_names_11_melachim_b_25_txt()
      }

  internal val names_11_melachim_b_txt: AssetResource by lazy { init_names_11_melachim_b_txt() }

  internal val names_12_yeshaaya_07_txt: AssetResource by lazy { init_names_12_yeshaaya_07_txt() }

  internal val names_12_yeshaaya_08_txt: AssetResource by lazy { init_names_12_yeshaaya_08_txt() }

  internal val names_12_yeshaaya_13_txt: AssetResource by lazy { init_names_12_yeshaaya_13_txt() }

  internal val names_12_yeshaaya_14_txt: AssetResource by lazy { init_names_12_yeshaaya_14_txt() }

  internal val names_12_yeshaaya_15_txt: AssetResource by lazy { init_names_12_yeshaaya_15_txt() }

  internal val names_12_yeshaaya_16_txt: AssetResource by lazy { init_names_12_yeshaaya_16_txt() }

  internal val names_12_yeshaaya_17_txt: AssetResource by lazy { init_names_12_yeshaaya_17_txt() }

  internal val names_12_yeshaaya_19_txt: AssetResource by lazy { init_names_12_yeshaaya_19_txt() }

  internal val names_12_yeshaaya_22_txt: AssetResource by lazy { init_names_12_yeshaaya_22_txt() }

  internal val names_12_yeshaaya_23_txt: AssetResource by lazy { init_names_12_yeshaaya_23_txt() }

  internal val names_12_yeshaaya_36_txt: AssetResource by lazy { init_names_12_yeshaaya_36_txt() }

  internal val names_12_yeshaaya_37_txt: AssetResource by lazy { init_names_12_yeshaaya_37_txt() }

  internal val names_12_yeshaaya_38_txt: AssetResource by lazy { init_names_12_yeshaaya_38_txt() }

  internal val names_12_yeshaaya_39_txt: AssetResource by lazy { init_names_12_yeshaaya_39_txt() }

  internal val names_12_yeshaaya_txt: AssetResource by lazy { init_names_12_yeshaaya_txt() }

  internal val names_13_yirmeyah_20_txt: AssetResource by lazy { init_names_13_yirmeyah_20_txt() }

  internal val names_13_yirmeyah_26_txt: AssetResource by lazy { init_names_13_yirmeyah_26_txt() }

  internal val names_13_yirmeyah_28_txt: AssetResource by lazy { init_names_13_yirmeyah_28_txt() }

  internal val names_13_yirmeyah_29_txt: AssetResource by lazy { init_names_13_yirmeyah_29_txt() }

  internal val names_13_yirmeyah_32_txt: AssetResource by lazy { init_names_13_yirmeyah_32_txt() }

  internal val names_13_yirmeyah_35_txt: AssetResource by lazy { init_names_13_yirmeyah_35_txt() }

  internal val names_13_yirmeyah_36_txt: AssetResource by lazy { init_names_13_yirmeyah_36_txt() }

  internal val names_13_yirmeyah_37_txt: AssetResource by lazy { init_names_13_yirmeyah_37_txt() }

  internal val names_13_yirmeyah_38_txt: AssetResource by lazy { init_names_13_yirmeyah_38_txt() }

  internal val names_13_yirmeyah_40_txt: AssetResource by lazy { init_names_13_yirmeyah_40_txt() }

  internal val names_13_yirmeyah_41_txt: AssetResource by lazy { init_names_13_yirmeyah_41_txt() }

  internal val names_13_yirmeyah_43_txt: AssetResource by lazy { init_names_13_yirmeyah_43_txt() }

  internal val names_13_yirmeyah_45_txt: AssetResource by lazy { init_names_13_yirmeyah_45_txt() }

  internal val names_13_yirmeyah_46_txt: AssetResource by lazy { init_names_13_yirmeyah_46_txt() }

  internal val names_13_yirmeyah_47_txt: AssetResource by lazy { init_names_13_yirmeyah_47_txt() }

  internal val names_13_yirmeyah_48_txt: AssetResource by lazy { init_names_13_yirmeyah_48_txt() }

  internal val names_13_yirmeyah_49_txt: AssetResource by lazy { init_names_13_yirmeyah_49_txt() }

  internal val names_13_yirmeyah_50_txt: AssetResource by lazy { init_names_13_yirmeyah_50_txt() }

  internal val names_13_yirmeyah_51_txt: AssetResource by lazy { init_names_13_yirmeyah_51_txt() }

  internal val names_13_yirmeyah_52_txt: AssetResource by lazy { init_names_13_yirmeyah_52_txt() }

  internal val names_13_yirmeyah_txt: AssetResource by lazy { init_names_13_yirmeyah_txt() }

  internal val names_14_yechezkel_01_txt: AssetResource by lazy { init_names_14_yechezkel_01_txt() }

  internal val names_14_yechezkel_24_txt: AssetResource by lazy { init_names_14_yechezkel_24_txt() }

  internal val names_14_yechezkel_25_txt: AssetResource by lazy { init_names_14_yechezkel_25_txt() }

  internal val names_14_yechezkel_26_txt: AssetResource by lazy { init_names_14_yechezkel_26_txt() }

  internal val names_14_yechezkel_27_txt: AssetResource by lazy { init_names_14_yechezkel_27_txt() }

  internal val names_14_yechezkel_28_txt: AssetResource by lazy { init_names_14_yechezkel_28_txt() }

  internal fun values(): List<AssetResource> = listOf(names_11_melachim_b_18_txt,
      names_11_melachim_b_19_txt, names_11_melachim_b_20_txt, names_11_melachim_b_21_txt,
      names_11_melachim_b_23_txt, names_11_melachim_b_24_txt, names_11_melachim_b_25_txt,
      names_11_melachim_b_txt, names_12_yeshaaya_07_txt, names_12_yeshaaya_08_txt,
      names_12_yeshaaya_13_txt, names_12_yeshaaya_14_txt, names_12_yeshaaya_15_txt,
      names_12_yeshaaya_16_txt, names_12_yeshaaya_17_txt, names_12_yeshaaya_19_txt,
      names_12_yeshaaya_22_txt, names_12_yeshaaya_23_txt, names_12_yeshaaya_36_txt,
      names_12_yeshaaya_37_txt, names_12_yeshaaya_38_txt, names_12_yeshaaya_39_txt,
      names_12_yeshaaya_txt, names_13_yirmeyah_20_txt, names_13_yirmeyah_26_txt,
      names_13_yirmeyah_28_txt, names_13_yirmeyah_29_txt, names_13_yirmeyah_32_txt,
      names_13_yirmeyah_35_txt, names_13_yirmeyah_36_txt, names_13_yirmeyah_37_txt,
      names_13_yirmeyah_38_txt, names_13_yirmeyah_40_txt, names_13_yirmeyah_41_txt,
      names_13_yirmeyah_43_txt, names_13_yirmeyah_45_txt, names_13_yirmeyah_46_txt,
      names_13_yirmeyah_47_txt, names_13_yirmeyah_48_txt, names_13_yirmeyah_49_txt,
      names_13_yirmeyah_50_txt, names_13_yirmeyah_51_txt, names_13_yirmeyah_52_txt,
      names_13_yirmeyah_txt, names_14_yechezkel_01_txt, names_14_yechezkel_24_txt,
      names_14_yechezkel_25_txt, names_14_yechezkel_26_txt, names_14_yechezkel_27_txt,
      names_14_yechezkel_28_txt)
}

private fun init_names_11_melachim_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-18.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-18.txt")

private fun init_names_11_melachim_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-19.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-19.txt")

private fun init_names_11_melachim_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-20.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-20.txt")

private fun init_names_11_melachim_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-21.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-21.txt")

private fun init_names_11_melachim_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-23.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-23.txt")

private fun init_names_11_melachim_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-24.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-24.txt")

private fun init_names_11_melachim_b_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b-25.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b-25.txt")

private fun init_names_11_melachim_b_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_11_melachim_b.txt\")") as String, rawPath =
    "peopleNames/names_11_melachim_b.txt")

private fun init_names_12_yeshaaya_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-07.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-07.txt")

private fun init_names_12_yeshaaya_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-08.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-08.txt")

private fun init_names_12_yeshaaya_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-13.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-13.txt")

private fun init_names_12_yeshaaya_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-14.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-14.txt")

private fun init_names_12_yeshaaya_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-15.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-15.txt")

private fun init_names_12_yeshaaya_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-16.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-16.txt")

private fun init_names_12_yeshaaya_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-17.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-17.txt")

private fun init_names_12_yeshaaya_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-19.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-19.txt")

private fun init_names_12_yeshaaya_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-22.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-22.txt")

private fun init_names_12_yeshaaya_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-23.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-23.txt")

private fun init_names_12_yeshaaya_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-36.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-36.txt")

private fun init_names_12_yeshaaya_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-37.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-37.txt")

private fun init_names_12_yeshaaya_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-38.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-38.txt")

private fun init_names_12_yeshaaya_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya-39.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya-39.txt")

private fun init_names_12_yeshaaya_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_12_yeshaaya.txt\")") as String, rawPath =
    "peopleNames/names_12_yeshaaya.txt")

private fun init_names_13_yirmeyah_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-20.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-20.txt")

private fun init_names_13_yirmeyah_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-26.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-26.txt")

private fun init_names_13_yirmeyah_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-28.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-28.txt")

private fun init_names_13_yirmeyah_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-29.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-29.txt")

private fun init_names_13_yirmeyah_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-32.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-32.txt")

private fun init_names_13_yirmeyah_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-35.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-35.txt")

private fun init_names_13_yirmeyah_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-36.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-36.txt")

private fun init_names_13_yirmeyah_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-37.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-37.txt")

private fun init_names_13_yirmeyah_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-38.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-38.txt")

private fun init_names_13_yirmeyah_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-40.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-40.txt")

private fun init_names_13_yirmeyah_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-41.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-41.txt")

private fun init_names_13_yirmeyah_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-43.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-43.txt")

private fun init_names_13_yirmeyah_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-45.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-45.txt")

private fun init_names_13_yirmeyah_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-46.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-46.txt")

private fun init_names_13_yirmeyah_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-47.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-47.txt")

private fun init_names_13_yirmeyah_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-48.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-48.txt")

private fun init_names_13_yirmeyah_49_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-49.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-49.txt")

private fun init_names_13_yirmeyah_50_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-50.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-50.txt")

private fun init_names_13_yirmeyah_51_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-51.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-51.txt")

private fun init_names_13_yirmeyah_52_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah-52.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah-52.txt")

private fun init_names_13_yirmeyah_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_13_yirmeyah.txt\")") as String, rawPath =
    "peopleNames/names_13_yirmeyah.txt")

private fun init_names_14_yechezkel_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-01.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-01.txt")

private fun init_names_14_yechezkel_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-24.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-24.txt")

private fun init_names_14_yechezkel_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-25.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-25.txt")

private fun init_names_14_yechezkel_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-26.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-26.txt")

private fun init_names_14_yechezkel_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-27.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-27.txt")

private fun init_names_14_yechezkel_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-28.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-28.txt")

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_18_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_18_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_19_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_19_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_20_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_20_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_21_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_21_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_23_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_23_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_24_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_24_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_25_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_25_txt

public actual val SharedRes.assets.peopleNames.names_11_melachim_b_txt: AssetResource
  get() = CommonMainAssets20.names_11_melachim_b_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_07_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_07_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_08_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_08_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_13_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_13_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_14_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_14_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_15_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_15_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_16_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_16_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_17_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_17_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_19_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_19_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_22_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_22_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_23_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_23_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_36_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_36_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_37_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_37_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_38_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_38_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_39_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_39_txt

public actual val SharedRes.assets.peopleNames.names_12_yeshaaya_txt: AssetResource
  get() = CommonMainAssets20.names_12_yeshaaya_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_20_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_20_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_26_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_26_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_28_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_28_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_29_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_29_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_32_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_32_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_35_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_35_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_36_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_36_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_37_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_37_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_38_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_38_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_40_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_40_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_41_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_41_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_43_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_43_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_45_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_45_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_46_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_46_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_47_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_47_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_48_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_48_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_49_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_49_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_50_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_50_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_51_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_51_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_52_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_52_txt

public actual val SharedRes.assets.peopleNames.names_13_yirmeyah_txt: AssetResource
  get() = CommonMainAssets20.names_13_yirmeyah_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_01_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_01_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_24_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_24_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_25_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_25_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_26_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_26_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_27_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_27_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_28_txt: AssetResource
  get() = CommonMainAssets20.names_14_yechezkel_28_txt
